import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import SectionHeader from "./SectionHeader";
import SectionCta from "./SectionCta";
import Styles from "./Features.module.css";

/**
 * TextGrid — `features` variation. Source: `.diff-grid` / `.diff-item`.
 * Accent rule + title + description, in a 2-up grid, no card fill.
 *
 * The source's decorative rule sits above the title; here it is the left rule
 * already used by `slices/Modules/Modules.module.css` `.title` and
 * `components/Card/Card.module.css` `.cardTitle::before`. It is a border, so no
 * decorative element enters the DOM and nothing needs aria-hidden.
 */
const Features = ({ primary, items }) => {
	return (
		<section
			className={Styles.wrapper}
			data-theme={primary?.dark_theme ? "dark" : "light"}>
			<div
				className={Styles.container}
				data-contain="true">
				<SectionHeader
					eyebrow={primary?.eyebrow}
					heading={primary?.heading}
					intro={primary?.intro}
				/>
				<ul className={Styles.grid}>
					{items?.map((item, index) => (
						<li
							className={Styles.feature}
							key={index}>
							<h3 className={Styles.title}>{item?.title}</h3>
							{isFilled.richText(item?.description) && (
								<div className={Styles.description}>
									<PrismicRichText field={item?.description} />
								</div>
							)}
						</li>
					))}
				</ul>
				<SectionCta
					label={primary?.cta_label}
					link={primary?.cta_link}
				/>
			</div>
		</section>
	);
};

export default Features;
